window.addEventListener("DOMContentLoaded", () => {
  const button = document.querySelector("#contact-button");
  const overlay = document.querySelector("#contact-overlay");
  const closeButton = overlay?.querySelector(".c-close-dialog button");
  //const success = document.querySelector("#contact-success");
  //const closeSuccessButton = success?.querySelector(".c-close-dialog button");

  if (!button || !overlay || !closeButton /*|| !success || !closeSuccessButton*/) return;
  onHashChange();
  window.addEventListener("hashchange", onHashChange, {
    passive: true
  });
  button.addEventListener("click", onOpenClick, {
    passive: true
  });
  closeButton.addEventListener("click", onCloseClick, {
    passive: true
  });
  //closeSuccessButton.addEventListener("click", onCloseClick, { passive: true });
  window.addEventListener("keydown", e => {
    if (e.key === "Escape" && overlay.open) onCloseClick();
  }, {
    passive: true
  });
  function onHashChange() {
    window.location.hash === "#contact" && !overlay.open ? overlay.showModal() : overlay.close();
    //if (window.location.hash === "#contact-success") {
    //  success.showModal();
    //  setTimeout(() => onCloseClick(), 5000);
    //} else {
    //  success.close();
    //}
  }
  function onOpenClick() {
    history.pushState(null, null, "#contact");
    onHashChange();
  }
  function onCloseClick() {
    history.pushState(null, null, "#");
    onHashChange();
  }
  requestAnimationFrame(() => {
    button.classList.add("duration-500");
    button.querySelector(".c-text")?.classList.add("duration-500");
  });
});